'use client'
import { keyframes, styled } from '@mui/material/styles'

type StatusDotTone = 'neutral' | 'waiting' | 'positive' | 'negative'

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
`

const StatusDot = styled('span', {
  shouldForwardProp: prop => prop !== 'tone' && prop !== 'pulsing',
})<{ tone?: StatusDotTone, pulsing?: boolean }>(({ theme, tone = 'neutral', pulsing = false }) => ({
  display: 'inline-block',
  flexShrink: 0,
  width: theme.sizes.spacing['03'],
  height: theme.sizes.spacing['03'],
  borderRadius: theme.sizes.radius.full,
  backgroundColor: {
    neutral: theme.colors.border.tertiary,
    waiting: theme.colors.surface['warning-primary'],
    positive: theme.colors.surface['success-primary'],
    negative: theme.colors.surface['error-primary'],
  }[tone],
  animation: pulsing ? `${pulse} 1.6s ease-in-out infinite` : 'none',
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
}))

export default StatusDot
export type { StatusDotTone }
